import React from 'react';
import { cn } from '../../lib/utils';
import './button.css';

const Button = React.forwardRef(({ 
  className, 
  variant = 'default', 
  size = 'default', 
  disabled,
  children, 
  ...props 
}, ref) => {
  return (
    <button
      className={cn(
        'btn',
        `btn-${variant}`,
        `btn-${size}`,
        disabled && 'btn-disabled',
        className
      )}
      ref={ref}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
